import { SvgIcon } from '@mui/material';

const VIEWBOX = '0 0 16 16';
const iconSx = { fontSize: 'inherit' } as const;

const CheckboxUncheckedIcon = () => (
  <SvgIcon viewBox={VIEWBOX} sx={iconSx}>
    <rect
      x="1"
      y="1"
      width="14"
      height="14"
      rx="3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </SvgIcon>
);

const CheckboxCheckedIcon = () => (
  <SvgIcon viewBox={VIEWBOX} sx={iconSx}>
    <rect x="0" y="0" width="16" height="16" rx="3" fill="currentColor" />
    <path
      d="M3.5 8L6.5 11L12.5 5"
      fill="none"
      style={{ stroke: 'var(--form-indicator-color)' }}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const CheckboxIndeterminateIcon = () => (
  <SvgIcon viewBox={VIEWBOX} sx={iconSx}>
    <rect x="0" y="0" width="16" height="16" rx="3" fill="currentColor" />
    <path
      d="M4 8H12"
      fill="none"
      style={{ stroke: 'var(--form-indicator-color)' }}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </SvgIcon>
);

export const checkboxIcon = <CheckboxUncheckedIcon />;
export const checkboxCheckedIcon = <CheckboxCheckedIcon />;
export const checkboxIndeterminateIcon = <CheckboxIndeterminateIcon />;
